var map = {
	"./footer.de-CH.json": 1073,
	"./footer.de-DE.json": 1074,
	"./footer.en-CA.json": 1075,
	"./footer.en-GB.json": 1076,
	"./footer.en-IN.json": 1077,
	"./footer.en-ME.json": 1078,
	"./footer.en-US.json": 1079,
	"./footer.es-EM.json": 1080,
	"./footer.es-ES.json": 1081,
	"./footer.fr-BE.json": 1082,
	"./footer.fr-CA.json": 1083,
	"./footer.fr-CH.json": 1084,
	"./footer.nl-BE.json": 1085,
	"./footer.nl-NL.json": 1086,
	"./footer.pl-PL.json": 1087,
	"./footer.pt-BR.json": 1088
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1072;